import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService, RequestBuilder, RequestTypeEnum } from '@client-monorepo/common/network';
import { CoinBalanceResponse } from '../models/CoinBalanceResponse';

@Injectable({
  providedIn: 'root',
})
export class PayClubApiService {
  apiService = inject(ApiService);

  getUserCoinBalance(): Observable<CoinBalanceResponse> {
    const request = new RequestBuilder(RequestTypeEnum.GET, 'scores/balance');
    return this.apiService.call<CoinBalanceResponse>(request);
  }
}
